// client/reactive-search-params.ts
import { BehaviorSubject, map } from "rxjs";
var ReactiveSearchParams = class extends BehaviorSubject {
  constructor(initialSearchParams = new URLSearchParams(window.location.search)) {
    super(initialSearchParams);
    this.paramsInstance = this.getValue();
  }
  next(newVal) {
    this.paramsInstance = newVal;
    super.next(newVal);
  }
  ping() {
    this.next(this.paramsInstance);
  }
  set(key, value) {
    if (this.paramsInstance.get(key) === value)
      return;
    this.paramsInstance.set(key, value);
    this.ping();
  }
  sort() {
    this.paramsInstance.sort();
    this.ping();
  }
  getOnce(key) {
    return this.paramsInstance.get(key);
  }
  get(key) {
    return this.pipe(map((qp) => qp.get(key)));
  }
  getAll(key) {
    return this.pipe(map((qp) => qp.getAll(key)));
  }
  delete(key) {
    this.paramsInstance.delete(key);
    this.ping();
  }
  has(key) {
    return this.paramsInstance.has(key);
  }
  entries() {
    return this.paramsInstance.entries();
  }
  toString() {
    return this.paramsInstance.toString();
  }
  static isEqualTo(a = new URLSearchParams({}), b = new URLSearchParams({})) {
    return Array.from(a.entries()).every(([key, value]) => b.get(key) === value) && Array.from(b.entries()).every(([key, value]) => a.get(key) === value);
  }
};
var queryParams = new ReactiveSearchParams();
export {
  ReactiveSearchParams,
  queryParams
};
